import type { BaseComponent } from "../BaseComponent";

export const UTM_PARAMETER_NAMES = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
] as const;

export type UtmParameterName = (typeof UTM_PARAMETER_NAMES)[number];

export interface UtmComponent extends BaseComponent {
  name: "utm";
  config: Record<string, never>;
}

export type UtmSubmission = Partial<Record<UtmParameterName, string>>;
